import React from 'react'
import styles from './StyleToolbar.scss'
import {RichUtils} from 'draft-js'
import {Popover} from 'common/Popover'
const preventDefault = (e) => e.preventDefault()

export const StyleToolbar = ({editorState, onChange, style, onAddLink, onRemoveLink, activeSelection}) => {
  if (editorState.getSelection().isCollapsed()) {
    return null
  }
  const currentStyle = editorState.getCurrentInlineStyle()

  const StyleButton = ({toggle, style, children}) => {
    const active = currentStyle.includes(toggle)
    return <li style={style}
      className={active && styles.activeButton}
      onMouseDown={preventDefault}
      onClick={() => onChange(RichUtils.toggleInlineStyle(editorState, toggle))}>
      {children}
    </li>
  }

  const linkButton = selectionIsLink(editorState)
    ? <li onMouseDown={preventDefault} onClick={onRemoveLink}>remove link</li>
    : <li onMouseDown={preventDefault} onClick={onAddLink}>link</li>

  return <Popover mountOnBody style={style} className={styles.StyleToolbar}>
    <StyleButton style={{ fontWeight: 'bold' }} toggle='BOLD'>bold</StyleButton>
    <StyleButton style={{ fontStyle: 'italic' }} toggle='ITALIC'>italic</StyleButton>
    <StyleButton style={{ textDecoration: 'underline' }} toggle='UNDERLINE'>underline</StyleButton>
    {linkButton}
  </Popover>
}

const selectionIsLink = (editorState) => {
  const selection = editorState.getSelection()
  const content = editorState.getCurrentContent()
  const leadingBlock = content.getBlockMap().get(selection.getStartKey())
  const entity = leadingBlock.getEntityAt(selection.getStartOffset())
  return entity && content.getEntity(entity).getType() === 'LINK'
}
